export function openOneTrustModal() {
  const oneTrust = window.OneTrust

  typeof oneTrust?.ToggleInfoDisplay === 'function'
  && oneTrust.ToggleInfoDisplay()
}
